// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VZBSfT0OZQ4OuYrzlbQr{padding:4px}.ovwUqO3SBiQrDs2NCiw3{padding:8px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `VZBSfT0OZQ4OuYrzlbQr`,
	"title": `ovwUqO3SBiQrDs2NCiw3`
};
export default ___CSS_LOADER_EXPORT___;
